export const useStyles = (theme) => ({
  root: {
    padding: 30,
    [theme.breakpoints.down(960)]: {
      paddingTop: 30,
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 5,
    },
  },
  gridContainer: {
    display: "flex",
    flexDirection: "row",
  },
  favoriteStyle: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  buttonRoot: {
    display: "flex",
    flexDirection: "column",
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    textTransform: "none",
    marginRight: 15,
    marginBottom: 10,
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
  notificationStyle: {
    top: 80,
    right: 10,
  },
  tabRoot: {
    color: "#0f1c50",
  },
  selectedStyle: {
    color: "#181818",
  },
  navStyle: {
    fontWeight: "bold",
    fontFamily: "Open Sans",
  },
  contentRoot: {
    width: "100%",
    marginTop: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    fontSize: 18,
  },
});
